import { motion, AnimatePresence } from "framer-motion";
import { useEffect, useState } from "react";

export default function Loader() {
  const [done, setDone] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setDone(true), 1900);
    return () => clearTimeout(t);
  }, []);
  return (
    <AnimatePresence>
      {!done && (
        <motion.div
          data-testid="site-loader"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.7, ease: [0.2, 0.7, 0.2, 1] }}
          className="fixed inset-0 z-[100] flex items-center justify-center bg-[#1E1E1E]"
        >
          <div className="relative flex flex-col items-center gap-6">
            <motion.img
              src="/serapark-logo-white.png"
              alt="SeramikPark"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.15, duration: 0.8 }}
              className="h-12 md:h-14 w-auto"
            />
            <div className="relative w-[240px] h-[1px] bg-white/10 overflow-hidden">
              <motion.div
                initial={{ x: "-100%" }}
                animate={{ x: "100%" }}
                transition={{ duration: 1.6, ease: [0.7, 0, 0.2, 1] }}
                className="absolute inset-y-0 w-full bg-[#B8860B]"
              />
            </div>
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 0.5 }}
              transition={{ delay: 0.4 }}
              className="text-[10px] tracking-[0.3em] uppercase text-white/50"
            >
              premium showroom
            </motion.div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
